module.exports = __webpack_public_path__ + "static/preview-tradee-52a2bb989cb2811701bdbff2b922855f.png";